//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CdnService from '@/service/cdn_config'
export default {
    data() {
        return {
            desc: '',
            lists: []
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        async initData() {
            const { page_config } = await CdnService.getDisclaimerConfig()
            this.desc = page_config.desc
            this.lists = page_config.lists
        },
    }
}
